/*
 * @ 防抖函数 SHW
 * @ wait 延迟毫秒数
 * @ immediate 立即执行
 * @ 启用immediate 则第一次 触发, 触发防抖后不触发, 按钮功能常用此模式
 * @ 不启用immediate 则 触发防抖后触发, 输入功能常用此模式
 */
const debounce = function () {
	let timeout = null
	return function (wait, immediate = true) {
		return new Promise(resolve => {
			if (timeout) {
				clearTimeout(timeout)
			}
			if (immediate) {
				let immediateAction = !timeout
				timeout = setTimeout(() => {
					timeout = null
				}, wait)
				if (immediateAction) {
					resolve()
				}
			} else {
				timeout = setTimeout(() => {
					resolve()
				}, wait)
			}
		})
	}
}

const fxDebounce = debounce()
export default {
	debounce,
	fxDebounce
}



// WEBPACK FOOTER //
// ./src/lib/util/src/debounce.js